import { Card, Typography, Image } from "antd";
import Percent from "@assets/KPMG/percent.svg";
import Rating from "@assets/KPMG/rating.svg";
import MarketPlaceImg from "@assets/KPMG/MarketPlace.png";
import Location from "@assets/KPMG/location.svg";
import { useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

interface CardItem {
  id: string;
  title: string;
  category: string;
  location: string;
  type?: string;
  rating: number;
  categoryIcon: string;
  description: string;
  provider?: string;
  techAdoption: string;
  solution?: string;
}

interface MyCardComponentProps {
  item: CardItem;
  index: number;
}

const MarketingCard: React.FC<MyCardComponentProps> = ({ item, index }) => {
  const navigate = useNavigate();
  return (
    <Card style={{ height: "100%" }}>
      <>
        <div>
          <Fade triggerOnce cascade damping={0.1}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <div>
                <Typography.Title
                  onClick={() =>
                    navigate(`/infratech-marketplace/view/${item.id}`)
                  }
                  level={5}
                  style={{ marginBottom: 0, cursor: "pointer" }}
                >
                  {item.title}
                </Typography.Title>
              </div>
              {item.type && (
                <div
                  style={{
                    padding: "4px 20px",
                    borderTopLeftRadius: 20,
                    borderBottomLeftRadius: 20,
                    background: "#ACEAFF",
                    marginRight: -24,
                  }}
                >
                  <div className="textSmall">{item.type}</div>
                </div>
              )}
            </div>
            <div style={{ display: "flex", marginBottom: 10, width: "100%" }}>
              <div style={{ display: "flex" }}>
                <Image src={Percent} preview={false} />
                <Typography.Text style={{ marginLeft: 10, color: "#1E49E2" }}>
                  {item.category}
                </Typography.Text>
              </div>
              <div style={{ display: "flex", marginLeft: 20 }}>
                <Image src={Location} preview={false} />
                <Typography.Text style={{ marginLeft: 10, color: "#1E49E2" }}>
                  {item.location}
                </Typography.Text>
              </div>
              <div style={{ display: "flex", marginLeft: 20 }}>
                <Image src={Rating} preview={false} />
                <Typography.Text style={{ marginLeft: 10, color: "#1E49E2" }}>
                  {item.rating}
                </Typography.Text>
              </div>
            </div>
            <div style={{ display: "flex", marginBottom: 0 }}>
              <div style={{ width: "30%" }}>
                <img
                  src={item.categoryIcon}
                  style={{ maxWidth: "100%", maxHeight: 180 }}
                />
              </div>
              <div style={{ width: "70%", marginLeft: 10 }}>
                <div>
                  <div style={{ marginBottom: 4 }}>
                    <Typography.Text style={{ color: "#14445E", fontSize: 12 }}>
                      Description
                    </Typography.Text>
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <Typography.Text style={{ color: "#5F5F5F", fontSize: 12 }}>
                      {item.description}
                    </Typography.Text>
                  </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <Typography.Text style={{ fontSize: 12 }}>
                    <span style={{ color: "#14445E" }}>Provider:</span>
                    <span style={{ marginLeft: 10, color: "#5F5F5F" }}>
                      {item.provider}
                    </span>
                  </Typography.Text>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <Typography.Text style={{ fontSize: 12 }}>
                    <span style={{ color: "#14445E" }}>Tech Adoption:</span>
                    <span style={{ marginLeft: 10, color: "#5F5F5F" }}>
                      {item.techAdoption}
                    </span>
                  </Typography.Text>
                </div>
                <div style={{ marginBottom: 0 }}>
                  <Typography.Text style={{ fontSize: 12 }}>
                    <span style={{ color: "#14445E" }}>Solution:</span>
                    <span style={{ marginLeft: 10, color: "#5F5F5F" }}>
                      {item.solution}
                    </span>
                  </Typography.Text>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </>
    </Card>
  );
};

export default MarketingCard;
